import React, { Component } from "react";
import { Button, Modal, Image, Form } from "react-bootstrap";
import Meeting from "../../assets/meeting.svg";
import Calendar from "../../assets/add-decision-calendar.svg";
import Venue from "../../assets/venue.svg";
import ChairedBy from "../../assets/created-by.svg";
import { Field } from "../../component";
import EditIcon from "../../assets/ci_red_edit.svg";
import { DisplayAttachments } from "../reusableComponent";
import { UploadAttachmentsWithTitleComponent } from "./downloadAttachements";
import {
  ERROR_MSG,
  PATHS,
  DOCUMENT_FORMATS,
  ISSUE_DECISION_DETAILS
} from "../../constant";
import {
  getLocalstorage,
  dateFormat,
  getDayOfTheGivenDate,
  getTimeOfTheGivenDate,
  getAgendaTagsColor
} from "../../helper";
import { get, isFunction } from "lodash";
import { toast } from "react-toastify";
import {
  successToastStyle,
  errorToastStyle,
  infoToastStyle
} from "../../customToast";
import { addProjectDecisionAction } from "../../actions/addDecision.action";
import { LoaderPage } from "../../component/Loader";
import { modifyDataForProjectDecisionPost } from "./helper";

export default class ProjectAddDecisionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //modal_open: false,
      showLoader: false,
      files: [
        // {
        //   id: 15124,
        //   title: null,
        //   mineType: null,
        //   name: "Dolores oportere te nec. Ne.PNG",
        //   s3Url:
        //     "https://pmiic-non-prod-assets.s3.ap-south-1.amazonaws.com/1717138615594-Capture1.PNG",
        //   s3FileName: "1717138615594-Capture1.PNG"
        // }
        //   {
        //     "id": 15124,
        //     "title": null,
        //     "mineType": null,
        //     "name": "Dolores oportere te nec. Ne.PNG",
        //     "s3Url": "https://pmiic-non-prod-assets.s3.ap-south-1.amazonaws.com/1717138615594-Capture1.PNG",
        //     "s3FileName": "1717138615594-Capture1.PNG"
        // },
      ],
      toggleAttachementDisplay: false,
      description: "",
      errormsg: "",
      agendaName: "",
      meetingDate: null,
      meetingTimeFrom: null,
      meetingTimeTo: null,
      venue: null,
      meetingChairedBy: "",
      projectMOM: "",
      projectMeetingType: "",
      meetingMode: "",
      //"fileAttachment": [],
      projectId: null,
      meetingId: null,
      id: 0
      //projectDecisionId: null
    };
  }
  componentWillMount() {
    //console.log("hello hello component")
    const { agendaDetails, project, meetingData: meetingDecision } = this.props;
    console.log("meetingDecision", meetingDecision);
    const projectMeetingDTO = get(project, "projectDecisions", []);
    this.setState({
      agendaName: get(agendaDetails, "agendaName", null),
      meetingDate: get(agendaDetails, "meetingDate", null),
      meetingTimeFrom: get(agendaDetails, "meetingTimeFrom", null),
      meetingTimeTo: get(agendaDetails, "meetingTimeTo", null),
      venue: get(agendaDetails, "venue", null),
      meetingChairedBy: get(agendaDetails, "meetingChairedBy", null),
      projectMeetingType: get(agendaDetails, "meetingType", null),
      meetingMode: get(agendaDetails, "meetingMode", null),
      projectId: get(project, "id", null),
      meetingId: get(agendaDetails, "id", null),
      id: get(meetingDecision, "id", null),
      files: get(meetingDecision, "fileDTOList", []),
      projectMOM: get(meetingDecision, "projectmom", null),
      isEditMode: projectMeetingDTO.length,
      error: {
        projectMOM: { error: false }
      }
    });
  }
  handleSubmit = async () => {
    const { handleClose, handleUpdateStatus, callApiOnSuccess } = this.props;
    const { projectMOM } = this.state;
    let isValid = true;

    // if (!projectMOM) {
    //   isValid = false;
    // }

    // if (isValid) {
    // if (projectMOM.trim() === "") {
    //   toast.error(
    //     <p className="toast-text-alignment">
    //       Please Enter Minutes of Meetings
    //     </p>,
    //     errorToastStyle
    //   );
    // } else {
    this.setState({ showLoader: true }, async () => {
      const response = await addProjectDecisionAction(
        undefined,
        modifyDataForProjectDecisionPost({ ...this.state })
      );
      if (response) {
        this.setState({ showLoader: false });
        //console.log(response);
        const { message, status } = response;
        if (status) {
          toast.success(
            <p className="toast-text-alignment">
              Minutes Submitted Successfully.
            </p>,
            successToastStyle
          );
          handleClose();
          typeof handleUpdateStatus === "function" && handleUpdateStatus();
          isFunction(callApiOnSuccess) && callApiOnSuccess();
        } else {
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
        }
      }
    });
    // }
    // } else {
    //   this.setState(prevState => ({
    //     error: {
    //       ...prevState.error,
    //       projectMOM: {
    //         error: !projectMOM,
    //         message: !projectMOM && ERROR_MSG.DEFAULT_MSG
    //       }
    //     },
    //     showLoader: false
    //   }));
    //   toast.error(
    //     <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
    //     errorToastStyle
    //   );
    // }
  };
  onChange = (value, key) => {
    this.setState({ projectMOM: value, errormsg: "" });
  };

  onError = (value, key) => {
    this.setState(prevState => ({
      error: {
        ...prevState.error,
        [key]: value
      }
    }));
  };
  onToggleAttachment = file => {
    this.setState(prevState => {
      return {
        toggleAttachementDisplay: !prevState.toggleAttachementDisplay,
        files: file ? [file, ...prevState.files] : prevState.files
      };
    });
  };
  onBlur = value => {};
  onRemoveFile = ({ id }) => {
    try {
      this.setState(prevState => ({
        files: prevState.files.filter(value => value.id !== id),
        toggleAttachementDisplay: false
      }));
    } catch (error) {
      console.log(`Error while deleting the image ${error.message}`);
    }
  };
  render() {
    const {
      onToggleModalPopUp,
      onToggleAttachment,
      onRemoveFile,
      onToogleChildIssuePopUp
    } = this;
    const {
      toggleAttachementDisplay,
      projectMOM,
      errormsg,
      error,
      showLoader,
      id,
      meetingId
    } = this.state;
    const {
      agendaDetails,
      project,
      displayProjectPopUp,
      handleClose,
      title,
      meetingDecision
    } = this.props;
    const isEditMode = title === "Edit";

    return (
      <>
        <LoaderPage loading={showLoader} />

        <Modal
          size="lg"
          show={displayProjectPopUp}
          onHide={handleClose}
          aria-labelledby="example-modal-sizes-title-lg"
          className="content-modal"
        >
          <div className="agenda-project-add-decision-modal">
            <Modal.Header
              closeButton
              className="header-modal"
              style={{ backgroundColor: "#E7EFFB" }}
            >
              <Modal.Title
                id="example-modal-sizes-title-lg"
                style={{
                  paddingLeft: "2.5%",
                  paddingTop: "1.5%",
                  paddingBottom: "1.5%",
                  fontSize: 20
                }}
              >
                {isEditMode ? "Edit" : "Add"} Decision
              </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: "25px 4% 20px" }}>
              <div className="row">
                <div className="col-md-4 left-div-projectdecision">
                  <div
                    className="flex-width d-flex agenda-card-chairedby project-dec-img"
                    style={{ width: "auto", paddingTop: 18, paddingLeft: 2 }}
                  >
                    <span>
                      <Image src={Calendar} />
                    </span>
                    <div>
                      <span>
                        <b>When</b>
                        <br />
                        {getDayOfTheGivenDate(agendaDetails.meetingDate) +
                          ", " +
                          dateFormat(get(agendaDetails, "meetingDate"))}
                        ,{" "}
                        {agendaDetails.meetingTimeFrom !== null &&
                          agendaDetails.meetingTimeFrom !== 0 &&
                          getTimeOfTheGivenDate(agendaDetails.meetingTimeFrom)}
                      </span>
                    </div>
                  </div>
                  <div
                    className="flex-width d-flex agenda-card-chairedby project-dec-img"
                    style={{ width: "auto", paddingTop: 22, paddingLeft: 2 }}
                  >
                    <span>
                      <Image src={Venue} />
                    </span>
                    <div>
                      <span>
                        <b>Venue</b>
                        <br />
                        {get(agendaDetails, "venueName", null)}
                        {/* {agendaDetails && agendaDetails.mode} */}
                      </span>
                    </div>
                  </div>
                  <div
                    className="flex-width d-flex agenda-card-chairedby project-dec-img"
                    style={{ width: "auto", paddingTop: 22, paddingLeft: 2 }}
                  >
                    <span>
                      <Image src={Meeting} />
                    </span>
                    <div>
                      <span>
                        <b>Meeting Type</b>
                        <br />
                        {get(agendaDetails, "meetingType", null) || "NA"}
                        {/* {agendaDetails && agendaDetails.mode} */}
                      </span>
                    </div>
                  </div>
                  <div
                    className="flex-width d-flex agenda-card-chairedby project-dec-img"
                    style={{
                      width: "auto",
                      paddingTop: 22,
                      paddingBottom: 18,
                      paddingLeft: 2
                    }}
                  >
                    <span>
                      <Image src={ChairedBy} />
                    </span>
                    <div>
                      <span>
                        <b>Chaired By</b>
                        <br />
                        {get(agendaDetails, "meetingChairedBy", null)}
                        {/* {agendaDetails && agendaDetails.mode} */}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-8 right-div-agenda-add-decision">
                  <div
                    className="decision-issue-status"
                    style={{ marginBottom: 0 }}
                  >
                    <Form.Group className="form-field d-flex flex-row align-items-center justify-content-between">
                      <div className="w-full" style={{ paddingLeft: 0 }}>
                        <Form.Label style={{ fontSize: 15 }} className="p-0">
                          Minutes of Meetings{" "}
                          {/* <span className="required">*</span> */}
                        </Form.Label>
                        <div className="form-field">
                          <Field
                            as="textarea"
                            keyName="projectMOM"
                            onChange={this.onChange}
                            // onError={this.onError}
                            value={projectMOM}
                            //isInvalid={errormsg != ""}
                            // isInvalid={get(error, "projectMOM.error")}
                            className="agenda-mom-input"
                            placeholder="Enter minutes of the meeting"
                            onBlur={this.onBlur}
                          />
                          {/* <Form.Control.Feedback type="invalid">
                            {get(error, "projectMOM.message")}
                          </Form.Control.Feedback> */}
                        </div>
                      </div>
                    </Form.Group>
                  </div>
                  <div className="add-decision-meeting agendaproject-add-decision-meeting">
                    <DisplayAttachments
                      onTogglePopUp={onToggleAttachment}
                      filesArr={this.state.files}
                      onRemoveFile={onRemoveFile}
                      isAgendaAttachment={true}
                      buttonTitle="ADD DOCUMENT(S)"
                      projectAdddecision={true}
                    />
                  </div>

                  {toggleAttachementDisplay ? (
                    <UploadAttachmentsWithTitleComponent
                      displayModal={toggleAttachementDisplay}
                      onCloseModal={onToggleAttachment}
                      fileFormats={DOCUMENT_FORMATS}
                    />
                  ) : null}
                </div>
              </div>
            </Modal.Body>
            <div style={{ float: "right", paddingBottom: 18 }}>
              {isEditMode ? (
                <Button
                  className="btn-orange no-padding agenda-add-decision-meeting-btn"
                  onClick={this.handleSubmit}
                >
                  UPDATE DECISION
                </Button>
              ) : (
                <Button
                  className="btn-orange no-padding agenda-add-decision-meeting-btn"
                  onClick={this.handleSubmit}
                >
                  SUBMIT DECISION
                </Button>
              )}
            </div>
          </div>
        </Modal>
      </>
    );
  }
}
